import styles from './ShowSuccessfulIncidentCreationModal.module.css';
import Modal from '../UI/modal/Modal';

interface IShowSuccessfulIncidentCreationModal {
  visible: boolean;
  closeShowSuccessfulIncidentCreationModalCallbackHandler: (flag: boolean) => void;
  zoomLink: string;
}

const ShowSuccessfulIncidentCreationModal = ({
  closeShowSuccessfulIncidentCreationModalCallbackHandler,
  visible,
  zoomLink
}: IShowSuccessfulIncidentCreationModal) => {
  const closeModalHandler = () => {
    closeShowSuccessfulIncidentCreationModalCallbackHandler(false);
  };

  return (
    <Modal onClose={closeModalHandler} visible={visible}>
      <div className={styles.modalContent}>
        <h3 className={styles.successTitle}>✅ Incident Created Successfully</h3>
        <div className={styles.silverLine} />

        <p className={styles.message}>
          Your incident has been created. A responder will join you shortly. Please join the
          response call using the link below:
        </p>
        {/*Create zoom link object and add it in href placeholder*/}
        <a href={zoomLink} target="_blank" rel="noopener noreferrer" className={styles.zoomLink}>
          Join Incident Response Call
        </a>
        <div className={styles.buttonGroup}>
          <button type="button" className={styles.closeButton} onClick={closeModalHandler}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ShowSuccessfulIncidentCreationModal;
